<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Experiencia</inertia-link>
      <span class="text-blue-400 font-medium">/</span> Crear {{form.titulo}}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <text-input v-model="form.titulo" :error="form.errors.titulo" class="pr-6 pb-8 w-full lg:w-1/2" label="Titulo" />
          <text-input v-model="form.link" :error="form.errors.link" class="pr-6 pb-8 w-full lg:w-1/2" label="Link" />
          <text-input v-model="form.mapongo" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Coordenadas en el Mapa" />
          <a href='http://www.google.com/maps?ll=-34.591327,-54.127965&spn=0.007092,0.016512&t=m&z=17' class="map" target='_blank'>Codigo del mapa</a><br>
          <text-input v-model="form.whatsapp" :error="form.errors.whatsapp" class="pr-6 pb-8 w-full lg:w-1/2" label="Whatsapp" />
          <select-input v-model="form.localidad" :error="form.errors.localidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Localidad">
            <option :value="null" />
            <option value="La Pedrera">La Pedrera</option>
            <option value="Punta Rubia">Punta Rubia</option>
            <option value="San Sebastián">San Sebastián</option>
            <option value="Arachania">Arachania</option>
            <option value="anta Isabel">Santa Isabel</option>
            <option value="Tajamares de La Pedrera">Tajamares de La Pedrera</option>
            <option value="La Serena Golf">La Serena Golf</option>
            <option value="San Antonio">San Antonio</option>
            <option value="Pueblo Nuevo">Pueblo Nuevo</option>
            <option value="Atlántica">Atlántica</option>
            <option value="Oceanía del Polonio">Oceanía del Polonio</option>
            <option value="La Paloma">La Paloma</option>
            <option value="Zona rural">Zona rural</option>
          </select-input>
          <div class="pr-6 pb-8 w-full">
            <label  class="form-label inline-block -mt-1">Descripcion corta:</label> 
            <vue-editor  v-model="form.descripcion" :error="form.errors.descripcion"  :editor-toolbar="customToolbar" />
           </div>
           <div class="pr-6 pb-8 w-full">
            <label  class="form-label inline-block -mt-1">Descripcion corta:</label> 
            <vue-editor  v-model="form.descripcion_larga" :error="form.errors.descripcion_larga" :editor-toolbar="customToolbar" />
           </div>
           <div class="pr-6 pb-8 w-full lg:w-1/3">
            <label  class="form-label inline-block -mt-1" for="act">Activado:</label> 
              <input v-model="form.publicado" :error="form.errors.publicado" class="mr-1" id="act" type="checkbox" />
           </div>
           <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label  class="form-label inline-block -mt-1" for="food">Experiencia Gastronomica:</label> 
              <input v-model="form.gastronomia" :error="form.errors.gastronomia" class="mr-1" id="food" type="checkbox" />
           </div>
          <!-- <text-area-input  class="pr-6 pb-8 w-full lg:w-1/2" label="Activado" /> -->
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Experiencia</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/Shared/TextAreaInput'
import { VueEditor } from "vue2-editor";


export default {
  metaInfo: { title: 'Crear Experiencia' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TextAreaInput,
    VueEditor
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        link: null,
        titulo: null,
        descripcion: null,
        foto: null,
        publicado: null,
        full_url: null,
        localidad: null,
        whatsapp: null,
        mapongo: null,
        descripcion_larga: null,
        gastronomia: null,
        
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('ads.store'))
    },
  },
}
</script>
